var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { css } from "@emotion/react";
import styled from "@emotion/styled";
import { tabMaxWidth } from "ui/components/panels/home-menu/home-menu.style";
export var ApplicationSelectTab = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\t", "\n"], ["\n\t", "\n"])), function () {
    return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\t\t\twidth: min(100%, ", ");\n\t\t\theight: 100%;\n\t\t"], ["\n\t\t\twidth: min(100%, ", ");\n\t\t\theight: 100%;\n\t\t"])), tabMaxWidth);
});
var templateObject_1, templateObject_2;
